import { Button, Input, Select } from "antd";
import React, { useState } from "react";
import SelectWithLabel from "../../component/FormInput/SelectWithLabel";
import { CloseOutlined } from "@ant-design/icons";

function FormSearchFacility({ changeValueInputSearch, dataSearch,disabled }) {
  return (
    <div>
      <span className="bold" style={{ marginRight: "20px", fontSize: "18px" }}>
        施設選択
      </span>
      <div style={{ marginBottom: "10px" }}>
        <SelectWithLabel
         disabled={disabled}
          onChange={(v) => {
            changeValueInputSearch("area", v);
          }}
          value={dataSearch.area.value}
          options={dataSearch.area.options}
          className="data-select w100"
          label={"処理区"}
          allTitle={true}
        ></SelectWithLabel>
      </div>
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}
      >
        <span
          className="bold"
          style={{ marginRight: "20px", fontSize: "16px" }}
        >
          施設一覧
        </span>
        <Input
         disabled={disabled}
          placeholder="施設検索キーワード"
          className="w100 cusom-input-search-facility "
          value={dataSearch.facilityName.value}
          onChange={(e) => {
            changeValueInputSearch("facilityName", e.target.value);
          }}
          suffix={
            <Button
              type="text"
              icon={<CloseOutlined style={{ fontSize: "12px" }} />}
                onClick={()=>  {
                  if(disabled){
                    return
                  }
                  changeValueInputSearch("facilityName", "")
                }}
              style={{
                color: "rgba(0,0,0,0.45)",
                borderLeft: "1px solid black",
                borderRadius: "0px",
                minWidth: "60px",
                transition: "background-color 0.3s ease",
              }}
            />
          }
          style={{ flex: 1, height: "40px" }}
        />
      </div>
    </div>
  );
}

export default FormSearchFacility;
